import axios from "axios";
import {IDENTITY_HEADER} from "../../utils/constants";

export const sendEmail = async (formData, identityHeader) => await axios.post("/api/email/send", formData, {
  headers: {
    'Content-Type': 'multipart/form-data',
    [IDENTITY_HEADER]: identityHeader
  }
})